import {
  GET_CLUB_SUBSCRIPTION_SHIPMENT_SUCCESS,
  RESET_CLUB_SUBSCRIPTION_VIRTUAL_SHIPMENT_ITEMS_SUCCESS,
  GET_CLUB_SUBSCRIPTION_VIRTUAL_SHIPMENT_SUCCESS,
  LIST_CLUB_SUBSCRIPTION_SHIPMENTS_SUCCESS,
  GET_CLUB_SUBSCRIPTION_SHIPMENT_VIRTUAL_CART_ITEMS_SUCCESS,
  GET_CLUB_SUBSCRIPTION_SHIPMENT_SKIP_UNSKIP_SUCCESS,
  GET_CLUB_SUBSCRIPTION_SHIPMENT_VIRTUAL_CART_ITEMS_ERROR
} from './constants';

const INITIAL_STATE = {
  data: null,
  virtualCart: null,
  originalVirtualCart: null, // Initial virtualCart for discarding changes
  isFetching: false
};

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GET_CLUB_SUBSCRIPTION_SHIPMENT_SUCCESS: {
      const data = { ...state.data };

      data[action.payload.id].items = action.payload.items;

      return {
        ...state,
        data,
        isFetching: false
      };
    }

    case GET_CLUB_SUBSCRIPTION_SHIPMENT_SKIP_UNSKIP_SUCCESS: {
      const data = { ...state.data };

      data[action.payload.id] = {
        ...data[action.payload.id],
        processingStatus: action.payload.processingStatus
      };

      return {
        ...state,
        data,
        isObjectFetching: false
      };
    }

    case RESET_CLUB_SUBSCRIPTION_VIRTUAL_SHIPMENT_ITEMS_SUCCESS: {
      const virtualCart = { ...state.virtualCart };
      const originalVirtualCart = { ...state.originalVirtualCart };

      virtualCart[action.payload.id] = originalVirtualCart[action.payload.id];

      virtualCart[action.payload.id].virtualTest = {
        isSuccess: true,
        missingCount: 0,
        missingTotal: 0
      };
      return {
        ...state,
        virtualCart,
        isFetching: false
      };
    }

    case GET_CLUB_SUBSCRIPTION_VIRTUAL_SHIPMENT_SUCCESS: {
      const virtualCart = { ...state.virtualCart };
      virtualCart[action.clubSubscriptionShipmentId] = action.payload;
      return {
        ...state,
        virtualCart,
        isFetching: false
      };
    }

    case LIST_CLUB_SUBSCRIPTION_SHIPMENTS_SUCCESS: {
      const data = { ...state.data };

      action.payload.clubSubscriptionShipments.forEach(
        (clubSubscriptionShipment) => {
          data[clubSubscriptionShipment.id] = clubSubscriptionShipment;
        }
      );
      return {
        ...state,
        data,
        isFetching: false
      };
    }

    case GET_CLUB_SUBSCRIPTION_SHIPMENT_VIRTUAL_CART_ITEMS_SUCCESS: {
      const virtualCart = { ...state.virtualCart };
      const originalVirtualCart = { ...state.originalVirtualCart };

      // // we need to store initialVirtualCart in order to discard changes to default one
      originalVirtualCart[action.clubSubscriptionShipmentId] = action.payload;

      virtualCart[action.clubSubscriptionShipmentId] = action.payload;
      virtualCart[action.clubSubscriptionShipmentId].virtualTest = {
        isSuccess: true,
        missingCount: 0,
        missingTotal: 0
      };
      return {
        ...state,
        originalVirtualCart,
        virtualCart,
        isFetching: false
      };
    }

    case GET_CLUB_SUBSCRIPTION_SHIPMENT_VIRTUAL_CART_ITEMS_ERROR: {
      const data = { ...state.data };
      data[action.clubSubscriptionShipmentId].virtualCartError =
        action.payload.errorMessage;

      return {
        ...state,
        data,
        isFetching: false
      };
    }
    default:
      return state;
  }
};

export default reducer;
